import React, { Dispatch, FC, SetStateAction } from "react";
import { useOnChangeChildDispatch } from "utils/OnChange";
import { SearchWidgetTextBlockThemeBuilder } from "./TextBlockThemeBuilder";
import { ThemeBuilderSection } from "../WidgetThemeBuilder/ThemeBuilderSection";
import { SearchWidgetBorderThemeBuilder } from "./SearchWidgetBorderThemeBuilder";
import { WidgetCardTheme } from "@xapp/intelligent-search-widget";
import { WidgetColorPicker } from "../WidgetThemeBuilder/WidgetColorPicker";
import { SearchWidgetLinkBlockThemeBuilder } from "./LinkBlockThemeBuilder";
import { WidgetMarginPicker } from "../WidgetThemeBuilder/WidgetMarginPicker";

export interface SearchWidgetCardThemeBuilderProps {
    readonly label?: string;
    readonly theme: WidgetCardTheme | undefined;
    readonly defaultTheme: WidgetCardTheme | undefined;
    readonly onChange: Dispatch<SetStateAction<WidgetCardTheme>>;
}

const EMPTY_THEME: WidgetCardTheme = {};

const SearchWidgetCardThemeBuilderInner: FC<SearchWidgetCardThemeBuilderProps> = props => {
    const theme: WidgetCardTheme = props.theme ?? EMPTY_THEME;
    const defaultTheme: WidgetCardTheme = props.defaultTheme ?? EMPTY_THEME;

    const { onChange } = props;

    const handleBorderChange = useOnChangeChildDispatch("border", onChange);
    const handleBackgroundChange = useOnChangeChildDispatch("background", onChange);
    const handleTitleChange = useOnChangeChildDispatch("title", onChange);
    const handleDescriptionChange = useOnChangeChildDispatch("description", onChange);
    const handleLinkChange = useOnChangeChildDispatch("link", onChange);
    const handleMarginChange = useOnChangeChildDispatch("margin", onChange);
    const handlePaddingChange = useOnChangeChildDispatch("padding", onChange);

    return (
        <ThemeBuilderSection heading={props.label ?? "Card"}>
            <WidgetColorPicker key="background" label="Background" value={theme.background} defaultValue={defaultTheme.background} onChange={handleBackgroundChange} />
            <SearchWidgetBorderThemeBuilder key="border" theme={theme.border} defaultTheme={defaultTheme.border} onChange={handleBorderChange} />
            <SearchWidgetTextBlockThemeBuilder key="title" label="Title" theme={theme.title} defaultTheme={defaultTheme.title} onChange={handleTitleChange} />
            <SearchWidgetTextBlockThemeBuilder key="description" label="Description" theme={theme.description} defaultTheme={defaultTheme.description} onChange={handleDescriptionChange} />
            <SearchWidgetLinkBlockThemeBuilder key="link" label="Link" theme={theme.link} defaultTheme={defaultTheme.link} onChange={handleLinkChange} />
            <WidgetMarginPicker key="margins" theme={theme.margin} defaultTheme={defaultTheme.margin} onChange={handleMarginChange} />
            <WidgetMarginPicker key="paddings" label="Paddings" theme={theme.padding} defaultTheme={defaultTheme.padding} onChange={handlePaddingChange} />
        </ThemeBuilderSection>
    );
};

export const SearchWidgetCardThemeBuilder = React.memo(SearchWidgetCardThemeBuilderInner);
